export const FETCH_EVENTOS_REQUEST = "FETCH_EVENTOS_REQUEST";
export const FETCH_EVENTOS_SUCCESS = "FETCH_EVENTOS_SUCCESS";
export const FETCH_EVENTOS_FAILURE = "FETCH_EVENTOS_FAILURE";

export const FETCH_EVENTO_ONE_SUCCESS = "FETCH_EVENTO_ONE_SUCCESS";
export const FETCH_EVENTO_ONE_FAILURE = "FETCH_EVENTO_ONE_FAILURE";
